export default "__VITE_ASSET__CAHWt1XZ__"